import { makeStyles } from '@material-ui/core/styles';

import theme from '../../MaterialUi/MaterialUi';

const useStyles = makeStyles({
	footerContainer: {
		padding: '1.5rem  0',
		position: 'absolute',
		left: '0',
		[theme.breakpoints.down('xs')]: {
			position: 'absolute',
			left: '0',
			right: '0',
		},
		margin: '4rem 0 0 0',
		width: '100%',
		display: 'flex',
		justifyContent: 'space-between',
		[theme.breakpoints.down('xs')]: {
			flexDirection: 'column',
		},
		backgroundColor: theme.palette.secondary.light,
	},
	footerContainers: {
		[theme.breakpoints.down('xs')]: {
			marginBottom: '2rem',
		},
	},
	footerTitles: {
		marginBottom: '0.3em',
	},
	buttons: {
		display: 'flex',
		justifyContent: 'center',
	},
	button: {
		color: theme.palette.secondary.contrastText,
		margin: '0 10px',
	},
});

export default useStyles;
